// Dependencies
import React from 'react';
import radium from 'radium';
import { connect } from 'react-redux';

import Pricelevel from '../../pricelevel-selection/pricelevel/Pricelevel.tsx';
import Button from '../../../components/button/Button.tsx';
import { addVisualTicket, removeVisualTicket, updatTicketPriceLevels } from '../../../redux/shoppingCartReducer';
import { setSeatInSelection } from '../../../redux/seatingplanPageReducer';
import sponsorCodeService from "../../../lib/sponsorCodes-service";

class SeatPricelevelSelection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedPriceLevelUuid: props.selectedPriceLevelUuid,
		};

		this.style = {
			contentWrapper: {
				margin: 'auto',
				'@media(min-width: 768px)': {
					margin: '4em 0',
				},
				width: '100%',
			},
			priceLevelHeading: {
				fontSize: '1.4em',
				marginBottom: '1em',
			},
			buttonWrapper: {
				'@media(min-width: 768px)': {
					display: 'flex',
				},
			},
			buttonContainer: {
				marginTop: '4em',
				width: '100%',
				'@media(min-width: 768px)': {
					width: '230px',
				},
			},
		};

		this.selectHandler = this.setTktAmount.bind(this);
	}

	setTktAmount(event) {
		const value = event.target.value;
		if (value) {
			this.setState({
				selectedPriceLevelUuid: value,
			});
		}
	}


	render() {
		return (
			<div style={this.style.contentWrapper}>
				<h1 style={this.style.priceLevelHeading} id={"pl_headline"}>Preisstufe</h1>
				<Pricelevel
					priceLevels={this.props.priceLevels}
					selectedPriceLevelUUID={this.state.selectedPriceLevelUuid}
					onChange={this.selectHandler}
				/>
				<div style={this.style.buttonWrapper}>
					{this.props.seatDspTicket &&
						<Button
							name="deselectVisTktButton"
							buttonText="Abwählen"
							onClick={() => this.props.deselectSeat()}
							// btnStyle={'highlight'}
							buttonContainerStyle={this.style.buttonContainer}
							iconName={'minus-circle'}
						/>
					}
					<Button
						name={'visBulkTktButton'}
						buttonText="Auswahl übernehmen"
						onClick={() => this.props.chooseClicked(this.state.selectedPriceLevelUuid, this.props.seatDspTicket)}
						btnStyle={'highlight'}
						buttonContainerStyle={this.style.buttonContainer}
						iconName={'shopping-cart'}
					/>
				</div>
			</div>
		);
	}
}

// ------------------------------
// Store Connection
// ------------------------------
const mapStateToProps = (state, ownProps) => {
	const seatIdentifier = ownProps.seatIdentifier;
	const catUuid = state.seatState.seatInfoMap[seatIdentifier].categoryUUID;
	const stateCategory = state.event.elements[state.event.selected].categories.find(cat => cat.categoryUUID === catUuid);
	//category with sorted reduced price levels by position attribute
	const category = Object.assign({}, stateCategory, {
		reducedPriceLevels:[...stateCategory.reducedPriceLevels].sort((a, b) => {
			if ((a.pos === null) && (b.pos === null)) {
				return 0;
			}
			return a.pos > b.pos ? 1 : -1;
		}),
	})
	const shoppingcart = state.shoppingCart.elements[state.merchant.merchantId];
	const seatDspTicket = (shoppingcart.events || []).flatMap(scEvent => scEvent.displayTickets)
		.find((tkt) => (
			tkt.seatIdentifier === seatIdentifier &&
			tkt.categoryUuid === catUuid),
		);

	// Sponsor-Codes
	const sponsorReservations = state.sponsorCodes.seatReservations || [];
	const redeemedSponsorCodeUsages = Object.keys(state.sponsorCodes.codeUsagesPlUuidMap)
	let seatReservation = sponsorCodeService.getSponsorSeatReservation(sponsorReservations, seatIdentifier)
	const seatForRedeemedCodeReserved = sponsorCodeService.isSeatForRedeemedSponsorCodeReserved(sponsorReservations, seatIdentifier, redeemedSponsorCodeUsages)

	const isPlForSeatReservationAvailable = (pl) => {
		return seatForRedeemedCodeReserved && pl.priceLevelUuid === getPlUuidForReservedSeat()
	}
	const getPlUuidForReservedSeat = () => {
		return seatReservation ? state.sponsorCodes.codeUsagesPlUuidMap[seatReservation.codeUsageId] : null
	}
	// Filter Categories by code
	const priceLevels = [category.standardPriceLevel, ...category.reducedPriceLevels]
		.filter(pl =>
			pl != null &&
			(!pl.accessCodeNeeded || state.accessCodes.plUuidCodeMap[pl.priceLevelUuid]) &&
			(!pl.forSponsors || isPlForSeatReservationAvailable(pl))
		);

	const presetPlUuid = seatDspTicket ? seatDspTicket.priceLevelUuid
		: priceLevels.find(pl => pl.forSponsors)?.priceLevelUuid || priceLevels[0].priceLevelUuid

	return {
		category,
		priceLevels,
		selectedPriceLevelUuid: presetPlUuid,
		seatDspTicket,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	chooseClicked: async (selectedPriceLevelUuid, dspTicket) => {
		if (dspTicket) {
			dispatch(updatTicketPriceLevels(selectedPriceLevelUuid, dspTicket.ticketItemUuids));
		} else {
			dispatch(addVisualTicket(ownProps.seatIdentifier, selectedPriceLevelUuid));
		}
		dispatch(setSeatInSelection(null));
	},
	deselectSeat: () => {
		dispatch(removeVisualTicket(ownProps.seatIdentifier));
		dispatch(setSeatInSelection(null));
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(radium(SeatPricelevelSelection));
